import React, {useState, useRef, useEffect} from 'react';
import TeamShortTermGoalDisplay from './TeamShortTermGoalDisplay.mjs';
import TeamShortTermGoalEditForm from './TeamShortTermGoalEditForm.mjs';
import TeamShortTermGoalDefaultMessage from './TeamShortTermGoalDefaultMessage.mjs';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamShortTermGoal() 
{
    const { app_user, team, setTeam, team_member_role, short_term_goal, setShortTermGoal, 
            team_short_term_goals, setTeamShortTermGoals, setTeamCardDisplayRefresh } = useCTAL();

    const [deadline_date, setDeadlineDate] = useState("");
    const [deadline_date_style, setDeadlineDateStyle] = useState( { color: 'black' } );

    const [stg_display, setSTGDisplay] = useState( <TeamShortTermGoalDisplay /> );
    const [deadline_display, setDeadlineDisplay] = useState( <small>by {deadline_date}</small> );
    const [show_edit_stg, setShowEditSTG] = useState(false);
    const [results_display, setResultsDisplay] = useState(<></>); 
    const [error, setError] = useState();
    const [admin_message_display, setAdminMessageDisplay] = useState(<></>); 

    const tooltipRef_edit   = useRef(null);
    const tooltipRef_delete = useRef(null);
    
    const admin_message_style = { color: 'red' };

    useEffect(() => {
        const tooltip_edit   = new window.bootstrap.Tooltip(tooltipRef_edit.current,   { container: 'body', trigger: 'hover' });
        const tooltip_delete = new window.bootstrap.Tooltip(tooltipRef_delete.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_edit.dispose();
            tooltip_delete.dispose();
        };
    }, []);
    
    useEffect(() =>
    {
        if (!team) return;

        var is_disabled = true;
        if (team_member_role == "Admin") {
            is_disabled = false;
            setAdminMessageDisplay(<></>);
        }
        else if (short_term_goal) {
            setAdminMessageDisplay(<><span style={admin_message_style}><small>Modfiying/Deleting Goals requires Team Admin privileges</small></span></>)
        }        
    }, [team]);

    useEffect(() =>
    {
        if (short_term_goal) {
            refresh_stg_date();
            document.getElementById("stg-first-row").style.display = "block";
        }
        else { 
            setDeadlineDisplay();
            document.getElementById("stg-first-row").style.display = "none";
            if (team.NumShortTermGoals <= 0)
                setSTGDisplay(<TeamShortTermGoalDefaultMessage />);
        }
    }, [ short_term_goal ]);

    useEffect(() =>
    {
        if (DEBUG) console.log(`TeamShortTermGoal - show_edit_stg: ${show_edit_stg}`);

        if (!short_term_goal) return; 

        if (show_edit_stg) setSTGDisplay(<TeamShortTermGoalEditForm toggle_edit_stg={toggle_edit_stg} />)
        else setSTGDisplay(<TeamShortTermGoalDisplay />);
    }, [ show_edit_stg ]);

    const refresh_stg_date = () => { 
        if (DEBUG) console.log(`TeamShortTermGoal - Date Refresh: ${short_term_goal.DeadlineDate}`);
        setDeadlineDate(short_term_goal.DeadlineDate);
        setDeadlineDisplay( <small>by {short_term_goal.DeadlineDate}</small> );

        var datetime = new Date();
        var local_date = datetime.toLocaleDateString();
        var local_date_parts = local_date.split('/');
        var local_month = (local_date_parts[0].length < 2 ? `0${local_date_parts[0]}` : local_date_parts[0] );
        var local_day = (local_date_parts[1].length < 2 ? `0${local_date_parts[1]}` : local_date_parts[1] );
        var local_year = local_date_parts[2];
        var ymd_date = `${local_year}-${local_month}-${local_day}`;
      
        if (DEBUG) console.log(`ymd_date: ${ymd_date}`);
        if (DEBUG) console.log(`DeadlineDate: ${short_term_goal.DeadlineDate}`);

        if (short_term_goal.DeadlineDate < ymd_date) setDeadlineDateStyle( { color: 'red' } );
        else setDeadlineDateStyle( { color: 'black' } );
    }

    const toggle_edit_stg = () => { 
        if (team_member_role != "Admin") return;

        if (show_edit_stg) refresh_stg_date();
        else setDeadlineDisplay();

        setShowEditSTG(!show_edit_stg);
    }

    const reset_results = () => { setResultsDisplay(<></>); }
    const prepend_result = (result) => { setResultsDisplay( <> {result} {results_display} </>) }

    const create_result_success  = (message) => { return <div class="alert alert-success my-1 py-0" role="alert"><small>{message}</small></div>; }
    const create_result_error    = (message) => { return <div class="alert alert-danger  my-1 py-0" role="alert"><small>{message}</small></div>; }

    //Fairly simple update so avoiding a Team Bulk Fetch
    const update_local_short_term_goal = async () => { 
        if (!short_term_goal) return;
        if (team_short_term_goals.length <= 0) return;

        var stgs = team_short_term_goals.filter( stg => { return (stg.ShortTermGoalID != short_term_goal.ShortTermGoalID); } );
        await setTeamShortTermGoals(stgs);

        if (stgs.length > 0)
            setShortTermGoal(stgs[0]); //Default to most recent Goal
        else
            setShortTermGoal(undefined);

        var local_team = team;
        local_team.NumShortTermGoals = local_team.NumShortTermGoals - 1;
        setTeam(local_team);
        setTeamCardDisplayRefresh(true);
    }

    const handle_response = (res) => { 
        if (DEBUG) console.log(`TeamShortTermGoalEditForm - res.message: ${res.message}`);

        switch (res.result)
        {
            case "success"          : update_local_short_term_goal(); break;
            case "error"            : prepend_result(create_result_error(res.message));    break;
            default: break;
        }
    }

    const delete_stg = () => { 
        if ((!short_term_goal) || (!app_user) || (!team)) return;
        if (team_member_role != "Admin") return;

        var type = "delete_short_term_goal_ui";
        var team_id = team.TeamID;
        var stg_id = short_term_goal.ShortTermGoalID;
        var user_id = app_user.UserID;
        var user_full_name = app_user.UserFullName;
        
        var body = JSON.stringify({type, team_id, stg_id, user_id, user_full_name});
       
        console.log(`TeamShortTermGoal - Send Delete Short-Term Goal body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(response => response.json())
            .then(handle_response)
            .catch(setError);
    }
   
    return (
        <>
            {admin_message_display}
            <div id="stg-first-row">
                <div class="row">
                    <div class="col-9 col-lg-9" >
                        <span style={deadline_date_style}>{deadline_display}</span>
                    </div>
                    <div class="col-3 col-lg-3 text-end">
                        <div id="stg-modifiers">
                            <a href="#" ref={tooltipRef_edit}   data-bs-toggle="tooltip" data-bs-title="Edit Goal"   data-bs-delay="750"><img class="list_item_icon" src="./images/form.svg"  alt="edit"   border="0" onClick={toggle_edit_stg}/></a>
                            <a href="#" ref={tooltipRef_delete} data-bs-toggle="tooltip" data-bs-title="Delete Goal" data-bs-delay="750"><img class="list_item_icon-end" src="./images/trash.svg" alt="delete" border="0" onClick={delete_stg}/></a>                                
                        </div>
                    </div>
                </div>
            </div>
            {stg_display}
            {results_display}
        </>
    );
}
